import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { Text } from '@daedalus/atlas/Text';
import { getAuthenticationFlow } from '@daedalus/core/src/auth/modules/selectors';
import { AuthenticationFlows } from '@daedalus/core/src/auth/types/Auth';
const BottomSheetTitle = /*#__PURE__*/styled('div')({
  name: "BottomSheetTitle",
  class: "b1k6rakt",
  propsAsIs: false
});
const titles = defineMessages({
  default: {
    id: 'magicLinkModal.titleMemberDeals',
    defaultMessage: 'Unlock member deals for FREE!'
  },
  [AuthenticationFlows.DealFreeze]: {
    id: 'dealFreeze.susiTitle',
    defaultMessage: 'Sign in to freeze this deal'
  },
  vioDeal: {
    id: 'vioDeals.unlock',
    defaultMessage: 'Unlock Vio deals'
  }
});
const descriptions = defineMessages({
  default: {
    id: 'SUSI.joinMembers',
    defaultMessage: 'Join over 5,000,000 members who are saving on every booking'
  },
  [AuthenticationFlows.DealFreeze]: {
    id: 'dealFreeze.susiDescription',
    defaultMessage: 'Secure the price and availability of this stay – no card details required.'
  },
  vioDeal: {
    id: 'vioDeals.getFreeAccess',
    defaultMessage: 'Sign up to Vio.com to get free access to insider hotel deals and save up to 45% on your stays.'
  }
});
export const SignInTitle = () => {
  const {
    formatMessage
  } = useIntl();
  const authenticationFlow = useSelector(getAuthenticationFlow);
  const isDealFreezeFlow = authenticationFlow === AuthenticationFlows.DealFreeze;
  const title = formatMessage(isDealFreezeFlow ? titles[authenticationFlow] : titles.vioDeal);
  const description = formatMessage(isDealFreezeFlow ? descriptions[authenticationFlow] : descriptions.vioDeal);
  return <BottomSheetTitle>
      <Text variant="titleXL" dataId="vioDeals.unlock">
        {title}
      </Text>
      <div>
        <Text>{description}</Text>
      </div>
    </BottomSheetTitle>;
};

require("./SignInTitle.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SignInTitle.tsx");